import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import { AdminButton, AdminCard, AdminPageHeader } from '../../ui';
import toast from 'react-hot-toast';
import { ConsentRecord, getConsentHistory } from '../../../../api/admin/consent.api';

const POLICY_KEYS = [
  { key: '', label: 'Tất cả tính năng' },
  { key: 'ads-business', label: 'Cab Ads Doanh nghiệp' },
  { key: 'ads-personal', label: 'Quảng cáo cá nhân' },
  { key: 'ekyc-data', label: 'Định danh & Dữ liệu cá nhân' },
  { key: 'wallet-topup', label: 'Ví & Nạp tiền' },
  { key: 'ads-credit', label: 'Tín dụng / Trả sau' },
  { key: 'cabplus', label: 'Cab+ Pro' },
  { key: 'creator-payout', label: 'Creator & Quyết toán' },
  { key: 'affiliate', label: 'Tiếp thị liên kết' },
  { key: 'publisher', label: 'Publisher (Ads Network)' },
  { key: 'donate', label: 'Kênh Donate' },
];

const ManagementConsent: React.FC = () => {
  const [policyKey, setPolicyKey] = useState('');
  const [items, setItems] = useState<ConsentRecord[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      const res = await getConsentHistory(policyKey || undefined, 1, 500);
      setItems(res.items || []);
      setTotal(res.total || 0);
    } catch {
      toast.error('Không tải được lịch sử đồng ý.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policyKey]);

  const exportCsv = () => {
    const header = ['userId', 'policyKey', 'version', 'acceptedAt', 'ip'];
    const rows = items.map((r) =>
      [r.userId, r.policyKey, r.version, r.acceptedAt, r.ip || ''].map((v) => `"${String(v).replace(/"/g, '""')}"`).join(',')
    );
    const csv = [header.join(','), ...rows].join('\n');
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `consent-history-${policyKey || 'all'}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div className="adm-page">
      <AdminPageHeader
        title={
          <>
            Lịch sử đồng ý điều khoản <span style={{ color: 'var(--adm-muted)' }}>({total})</span>
          </>
        }
        actions={
          <>
            <select
              value={policyKey}
              onChange={(e) => setPolicyKey(e.target.value)}
              className="adm-select"
              aria-label="Lọc theo tính năng"
              style={{ width: 232 }}
            >
              {POLICY_KEYS.map((p) => (
                <option key={p.key} value={p.key}>{p.label}</option>
              ))}
            </select>
            <AdminButton elevated icon={<Download size={18} />} onClick={exportCsv} disabled={!items.length}>
              Xuất CSV
            </AdminButton>
          </>
        }
      />

      {loading ? (
        <p className="adm-muted" style={{ margin: 0 }}>Đang tải…</p>
      ) : items.length === 0 ? (
        <p className="adm-muted" style={{ margin: 0 }}>Chưa có dữ liệu đồng ý.</p>
      ) : (
        <AdminCard flush>
          <div className="adm-table-wrap">
            <table className="adm-table">
              <thead>
                <tr>
                  <th>User ID</th>
                  <th>Tính năng</th>
                  <th>Phiên bản</th>
                  <th>Thời gian đồng ý</th>
                  <th>IP</th>
                </tr>
              </thead>
              <tbody>
                {items.map((r) => (
                  <tr key={r.id}>
                    <td className="font-mono" style={{ fontSize: 12 }}>{r.userId}</td>
                    <td>
                      <span className="adm-status adm-status--neutral font-mono">{r.policyKey}</span>
                    </td>
                    <td>{r.version}</td>
                    <td>{new Date(r.acceptedAt).toLocaleString('vi-VN')}</td>
                    <td>{r.ip || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </AdminCard>
      )}
    </div>
  );
};

export default ManagementConsent;
